const mediaItems = [
  {
    title: '庆余年第二季 - 范闲归来',
    type: '预告片',
    duration: '02:35',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20drama%20trailer%20thumbnail%2C%20male%20lead%20in%20dark%20robe%20standing%20in%20ancient%20palace%20hall%2C%20dramatic%20golden%20lighting%2C%20epic%20scale%2C%20mysterious%20atmosphere%2C%20premium%20TV%20series%20visual&width=560&height=315&seq=media-trailer-01&orientation=landscape',
  },
  {
    title: '与凤行 - 三界大战',
    type: '精彩片段',
    duration: '04:12',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20action%20scene%20thumbnail%2C%20ethereal%20immortals%20battle%20with%20magical%20glowing%20effects%2C%20dramatic%20sky%20with%20clouds%2C%20epic%20cinematography%2C%20warm%20golden%20and%20red%20tones&width=560&height=315&seq=media-trailer-02&orientation=landscape',
  },
  {
    title: '狐妖小红娘 - 月红篇',
    type: '先导预告',
    duration: '01:48',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20teaser%20thumbnail%2C%20beautiful%20fox%20spirit%20female%20lead%20in%20pink%20ancient%20dress%2C%20cherry%20blossom%20magical%20atmosphere%2C%20soft%20dreamy%20lighting%2C%20enchanting%20visual&width=560&height=315&seq=media-trailer-03&orientation=landscape',
  },
  {
    title: '狂飙 - 经典名场面回顾',
    type: '花絮特辑',
    duration: '03:20',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20intense%20scene%20thumbnail%2C%20two%20actors%20in%20dark%20suits%20confrontation%2C%20urban%20night%20setting%2C%20dramatic%20noir%20lighting%2C%20gritty%20realistic%20style%2C%20high%20contrast&width=560&height=315&seq=media-trailer-04&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精彩预告</h2>
          <p className="text-sm text-foreground-500">热门影视精彩片段与预告抢先看</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group cursor-pointer">
              <div className="relative aspect-video rounded-xl overflow-hidden bg-background-200 mb-3">
                <img
                  src={item.img}
                  alt={`${item.title} ${item.type}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-xl text-primary-500 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/60 text-background-50 text-xs rounded-md">
                  {item.duration}
                </div>
                <div className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500/90 text-background-50 text-xs rounded-md">
                  {item.type}
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}